<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <DataTable
      :data="usuarios"
      :columns="columnas"
      idField="idUsuario"
      mensajeVacio="No hay usuarios registrados."
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="true"
      :mostrarEliminar="true"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idUsuario)"
      @view="row => abrirEditar(row.idUsuario)"
      @delete="row => deleteUsuario(row.idUsuario)"
    >
      <!-- Búsqueda por nombre -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar nombre..."
            style="width:220px"
            @keyup.enter="getDataNombre"
          />
          <button
            class="btn btn-outline-primary btn-sm"
            @click="getDataNombre"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- ID solo en edición -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">ID</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoUsuario.idUsuario" disabled />
                  </div>
                </div>
              </div>
              <!-- Perfil -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Perfil</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoUsuario.idPerfil" @change="cargarPermisosDesdePerfil">
                      <option disabled value="">Seleccione...</option>
                      <option v-for="p in perfils" :value="p.idPerfil" :key="p.idPerfil">{{ p.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Suscripción -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Suscripción</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoUsuario.idSuscripcion">
                      <option disabled value="">Seleccione...</option>
                      <option v-for="s in suscripcions" :value="s.idSuscripcion" :key="s.idSuscripcion">
                        {{ s.idSuscripcion }} — {{ s.numero }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Nombre -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Nombre</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoUsuario.nombre" required />
                  </div>
                </div>
              </div>
              <!-- Clave -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Clave</label></div>
                  <div class="col-10">
                    <input type="password" class="form-control" v-model="datoUsuario.clave" required />
                  </div>
                </div>
              </div>
              <!-- Persona -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Persona</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoUsuario.idPersona">
                      <option disabled value="">Seleccione...</option>
                      <option v-for="p in personas" :value="p.idPersona" :key="p.idPersona">{{ p.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Permisos como checkboxes -->
              <div class="mb-3">
                <label class="form-label fw-bold">Permisos</label>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-check" v-for="p in permisosCol1" :key="p.field">
                      <input class="form-check-input" type="checkbox" :id="p.field"
                        v-model="datoUsuario[p.field]" :true-value="1" :false-value="0" />
                      <label class="form-check-label" :for="p.field">{{ p.label }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-check" v-for="p in permisosCol2" :key="p.field">
                      <input class="form-check-input" type="checkbox" :id="p.field"
                        v-model="datoUsuario[p.field]" :true-value="1" :false-value="0" />
                      <label class="form-check-label" :for="p.field">{{ p.label }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-check" v-for="p in permisosCol3" :key="p.field">
                      <input class="form-check-input" type="checkbox" :id="p.field"
                        v-model="datoUsuario[p.field]" :true-value="1" :false-value="0" />
                      <label class="form-check-label" :for="p.field">{{ p.label }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Auditoría (solo edición) -->
              <div v-if="btnEditar">
                <hr />
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2"><label class="form-label fw-bold">Fecha Reg.</label></div>
                    <div class="col-4">
                      <input type="text" class="form-control" v-model="datoUsuario.fechaReg" disabled />
                    </div>
                    <div class="col-2"><label class="form-label fw-bold">Fecha Act.</label></div>
                    <div class="col-4">
                      <input type="text" class="form-control" v-model="datoUsuario.fechaAct" disabled />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarUsuario"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="guardarEditUsuario"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import config          from "@/config";
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

const PERMISOS_COL1 = [
  { field: "moduloAdministracion", label: "Módulo Administración" },
  { field: "moduloAtencion",       label: "Módulo Atención"       },
  { field: "moduloFacturacion",    label: "Módulo Facturación"    },
  { field: "moduloDashboards",     label: "Módulo Dashboards"     },
  { field: "moduloAuditoria",      label: "Módulo Auditoría"      },
];
const PERMISOS_COL2 = [
  { field: "menuParametros", label: "Menú Parámetros" },
  { field: "menuProcesos",   label: "Menú Procesos"   },
  { field: "menuReportes",   label: "Menú Reportes"   },
  { field: "menuAyuda",      label: "Menú Ayuda"      },
];
const PERMISOS_COL3 = [
  { field: "opcionConsulta",    label: "Opción Consulta"    },
  { field: "opcionOperaciones", label: "Opción Operaciones" },
  { field: "opcionDescarga",    label: "Opción Descarga"    },
  { field: "opcionMenu",        label: "Opción Menú"        },
];
const TODOS_PERMISOS = [...PERMISOS_COL1, ...PERMISOS_COL2, ...PERMISOS_COL3];

export default {
  name: "UsuarioList",
  components: { Layout, Footer, DataTable },

  props: {
    p_idEmpresa: { type: Number, required: true },
  },

  data() {
    return {
      usuarios:       [],
      datoUsuario:    {},
      nombreBusqueda: "",
      titulo:         "",
      btnCrear:       false,
      btnEditar:      false,
      modalWindow:    true,
      perfils:        [],
      suscripcions:   [],
      personas:       [],

      permisosCol1: PERMISOS_COL1,
      permisosCol2: PERMISOS_COL2,
      permisosCol3: PERMISOS_COL3,
    };
  },

  computed: {
    columnas() {
      return [
        { label: "Nombre",           field: "nombre"          },
        { label: "Perfil",           field: "perfilNombre"    },
        { label: "Documento",        field: "personaDocumento"},
        { label: "Persona",          field: "personaNombre"   },
        { label: "Empresa",          field: "empresaNombre"   },
      ];
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.getData();
    this.cargarAuxiliares();
  },

  methods: {
    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.nombreBusqueda = "";
      api.get("/vwusuarios/idempresa/"+this.p_idEmpresa)
        .then(r => { this.usuarios = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar usuarios:", e));
    },

    // ── Auxiliares con fetch + config ─────────────────────────
    cargarAuxiliares() {
      const cargar = (path, campo) => {
        fetch(config.apiBaseUrl + path)
          .then(r => r.json())
          .then(d => { this[campo] = d; })
          .catch(e => console.error(`Error fetching ${campo}:`, e));
      };
      cargar("/vwperfils",      "perfils");
      cargar("/vwsuscripcions", "suscripcions");
      cargar("/vwpersonas",     "personas");
    },

    // ── Cargar permisos desde perfil seleccionado ─────────────
    // Reemplaza el obtenerPerfil con parseo XML del original
    // usando los datos ya cargados en this.perfils
    cargarPermisosDesdePerfil() {
      const perfil = this.perfils.find(p => p.idPerfil === this.datoUsuario.idPerfil);
      if (!perfil) return;
      TODOS_PERMISOS.forEach(({ field }) => {
        this.datoUsuario[field] = perfil[field];
      });
    },

    // ── Validación ────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoUsuario,
        ["idPerfil", "idSuscripcion", "nombre", "clave", "idPersona"],
        ["Perfil", "Suscripción", "Nombre", "Clave", "Persona"]
      );
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarUsuario() {
      if (this.validarForm() !== 1) return;
      try {
        this.datoUsuario.idEmpresa    = this.p_idEmpresa;
        this.datoUsuario.idUsuarioReg = window.sessionStorage.getItem("idUsuario");
        // Copiar permisos desde el perfil seleccionado
        this.cargarPermisosDesdePerfil();
        await api.post("/usuarios", this.datoUsuario);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Usuario creado exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async guardarEditUsuario() {
      if (this.validarForm() !== 1) return;
      try {
        this.datoUsuario.idUsuarioAct = window.sessionStorage.getItem("idUsuario");
        await api.post("/usuarios", this.datoUsuario);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Usuario actualizado exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deleteUsuario(idUsuario) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar usuario?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/usuarios/" + idUsuario);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoUsuario = {};
      this.titulo      = "Crear Usuario";
      this.btnCrear    = true;
      this.btnEditar   = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idUsuario) {
      this.modalWindow = true;
      this.titulo      = "Editar Usuario";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp       = await api.get("/vwusuarios/" + idUsuario);
        this.datoUsuario = resp.data;
      } catch (e) {
        console.error("Error al cargar usuario:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    abrirEditar(idUsuario) {
      if (idUsuario != null) this.$router.push("/usuariomd/" + idUsuario);
    },
  },
};
</script>